<template>
  <div class="animated fadeIn">
    <b-card v-if="!loaded" class="text-center">
      <i class="fa fa-spinner fa-spin fa-4x"></i>
    </b-card>

    <b-card v-if="loaded" header-tag="header" footer-tag="footer">
      <template #header>
        <h3 class="mb-0">Inscrições
          <b-button class="pull-right" variant="info" @click="onClick">Exportar</b-button>
        </h3>
      </template>
        <kendo-pivotdatasource
          ref="pivotdatasource"
          :data="pivotData"
          :schema-model="schemaModel"
          :schema-cube="schemaCube"
          :measures="measures"
        >
          <kendo-pivot-column
            :name="'regiao_principal'"
            :expand="true"
          ></kendo-pivot-column>
          <kendo-pivot-row :name="'sexo'"></kendo-pivot-row>
          <kendo-pivot-row :name="'em_espera'"></kendo-pivot-row>
        </kendo-pivotdatasource>
      <div class="mb-1">
        <b-button v-if="configuraterShow" @click="minimizeConfig"><i class="fa fa-chevron-left"></i></b-button>
        <b-button v-if="!configuraterShow" @click="showConfig"><i class="fa fa-gear"></i></b-button>
      </div>
      <b-row>
        <b-col :md="configuratorCols" v-show="configuraterShow">
          <kendo-pivotconfigurator

            id="configurator"
            :data-source-ref="'pivotdatasource'"
            :filterable="true"
            style="width: 100%"
          >
          </kendo-pivotconfigurator>
        </b-col>
        <b-col :md="pivotCols">

          <kendo-pivotgrid
            id="pivotgrid"
            ref="camtilDashRegistrations"
            class="hidden-on-narrow"
            :data-source-ref="'pivotdatasource'"
            :filterable="true"
            :excel-file-name="'CAMTIL-DASH-INSCRICOES.xlsx'"
            :columnWidth="220"

          >
          </kendo-pivotgrid>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import kendo from "@progress/kendo-ui/js/kendo.all.js"; // eslint-disable-line no-unused-vars
import {
  PivotGrid,
  PivotConfigurator,
} from "@progress/kendo-pivotgrid-vue-wrapper";
import {
  PivotDataSource,
  PivotColumn,
  PivotRow,
} from "@progress/kendo-datasource-vue-wrapper";

export default {
  name: "dashboard",
  components: {
    "kendo-pivotgrid": PivotGrid,
    "kendo-pivotconfigurator": PivotConfigurator,
    "kendo-pivotdatasource": PivotDataSource,
    "kendo-pivot-column": PivotColumn,
    "kendo-pivot-row": PivotRow,
  },
  data() {
    return {
      loaded: false,
      configuraterShow: true,
      configuratorCols: 4,
      pivotCols: 8,
      pivotData: [],
      schemaModel: {
        fields: {
          pessoa: { type: "number" },
          familia: { type: "number" },
          regiao: { type: "string" },
          regiao_principal: { type: "string" },
          sexo: { type: "string" },
          escalao: { type: "string" },
        },
      },
      measures: ["Total Participantes"],
      schemaCube: {
        dimensions: {
          regiao: { caption: "Regioes" },
          sexo: { caption: "M/F" },
          escalao: { caption: "Escaloes" },
          regiao_principal: { caption: "Regioes principais" },
          actividade: { caption: "Actividades" },
          sub_actividade: { caption: "Sub-Actividades" },
          em_espera: { caption: "Em espera / Colocados" },
          veterano: { caption: "Veterano / Caloiro" },
        },
        measures: {
          "Total Participantes": {
            field: "pessoa",
            format: "{0:n0}",
            aggregate: this.CountDistinctAggregate,
          },
          "Total Familias": {
            field: "familia",
            format: "{0:n0}",
            aggregate: this.CountDistinctAggregate,
          },
        },
      },
    };
  },
  methods: {
    minimizeConfig() {
      this.configuraterShow = false
      this.configuratorCols = 4
      this.pivotCols = 12
    },
    showConfig() {
      this.configuraterShow = true
      this.configuratorCols = 4
      this.pivotCols = 8
    },
    CountDistinctAggregate(value, state, context) {
      if (!state.distinctList) {
        state.distinctList = new Array();
      }
      if ($.inArray(value, state.distinctList) < 0) {
        state.distinctList.push(value);
        return (state.accumulator || 0) + 1;
      } else {
        return state.accumulator || 0;
      }
    },
    onClick: function (ev) {
      var pivot = this.$refs.camtilDashRegistrations.kendoWidget();
      pivot.saveAsExcel();
    },
  },
  created() {
    this.axios.get("registrations/dashboard").then((response) => {
      this.pivotData = response.data.data;
      this.loaded = true;
    });
  },
};
</script>

<style>
/* IE fix */
.k-pivot-rowheaders {
  min-width: 180px;
}
</style>
